import { Splide } from "@splidejs/splide";


const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderBasic');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 400;
    let options = {
      type: "slide",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      gap: "0.5rem",
      arrows: false,
      pagination: false,
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
        autoplay: true,
      }
    }
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    const slider = new Splide(elm, options);
    slider.mount();
  }
}

const init = () => {
  // carousel();
}
export default init;